import React from 'react'
import AllQuestionsContent from './AllQuestionsContent'
import { useSelector } from 'react-redux'
import textSubmissionDrawerSelectors from '../../../../../store/selectors/text-submission-drawer.selectors'
import { ViewModes } from '../../../../../store/slices/text-submission-drawer.slice'
import { Card, Splitter } from 'antd'
import SubmissionPdfView from './SubmissionPdfView'

const TextSubmissionDrawerContent = ({ submissionId }) => {
    const viewMode = useSelector(textSubmissionDrawerSelectors.viewMode)

    if (viewMode === ViewModes.PDF) {
        return (
            <Splitter layout="horizontal" style={{ height: '100%' }}>
                <Splitter.Panel defaultSize="50%" minSize="20%">
                    <Card style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', marginRight: 8 }} styles={{ body: { flexGrow: 1, overflow: 'auto', padding: '0' /* Ensure Card body has no padding if PdfViewer needs full space */ } }}>
                        <SubmissionPdfView submissionId={submissionId} />
                    </Card>
                </Splitter.Panel>
                <Splitter.Panel defaultSize="50%" minSize="20%">
                    <div style={{height: '100%', overflowY: 'auto', marginLeft: 8}}>
                        <AllQuestionsContent submissionId={submissionId} />
                    </div>
                </Splitter.Panel>
            </Splitter>
        )
    }

    return (
        <div style={{ height: '100%', overflowY: 'auto' }}>
            <AllQuestionsContent submissionId={submissionId} />
        </div>
    )
}

export default TextSubmissionDrawerContent
